import { Component, OnInit } from '@angular/core';
import {AppComponent} from "../../../app.component";

@Component({
  selector: 'app-mobile-avatar',
  templateUrl: './mobile-avatar.component.html'
})
export class MobileAvatarComponent implements OnInit {

  constructor(public application: AppComponent) { }

  ngOnInit(): void {
  }

}
